import React, { useEffect, useState } from 'react'
import { StyledCreateRoom } from './styles'
import { useAppDispatch, useAppSelector } from '../../slices/store'
import { useNavigate } from 'react-router-dom'
import { ICreateRoomResponse, createRoom } from '../../slices/main/mainThunk'
import { Input } from '../../ui/Input/Input'
import { setNickname } from '../../slices/main/mainSlice'
import { Button } from '../../ui/Button/Button'
import { useTranslation } from 'react-i18next'

export const CreateRoom = () => {
  const { loading, userId } = useAppSelector(s => s.mainStore);
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const [adminName, setAdminName] = useState('');
  const [inputError, setInputError] = useState('');
  const [roomId, setRoomId] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (roomId && userId) {
      navigate(`/${roomId}`);
    }
  }, [roomId]);
  

  const handleClick = async () => {
    if (adminName) {
      const response = await dispatch(createRoom({admin_name: adminName, game_type: "music_mafia"}));
      dispatch(setNickname(adminName));
      setRoomId((response.payload as ICreateRoomResponse)?.room_id)
    } else {
      setInputError('*nickname is required');
    }
  }

  const handleInputChange = (value: string) => {
    if (inputError) {
      setInputError('');
    }
    setAdminName(value);
  }

  return (
    <StyledCreateRoom>
      <Input className="input-style" value={adminName} onEnter={handleClick} error={inputError} invalid={!!inputError} onChange={handleInputChange} placeholder={t('music_mafia.login.placeholder')} />
      <Button disabled={!adminName} title={t('music_mafia.login.create_room')} handleClick={handleClick} />
      <div className='description'>{t('music_mafia.login.admin_greeting')}</div>
    </StyledCreateRoom>
  )
}
